// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2dUeK","top":"styles_top__17vO8"};